<template>
<div class="chapter">
<div class="inner_page">
<h1>Die Lebensanschauungen</h1>
<h1 class="sigil_not_in_toc">Der großen Denker</h1>
<h2 class="sigil_not_in_toc">Rudolf Eucken</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?3b2ab61e